import { useUserStore } from "@/lib/stores/userStore";
import { createClient } from "@/utils/supabase/client";
import { useEffect } from "react";

/**
 * Hook to get the current user and their details.
 */
export const useUser = () => {
  const { user, isNowadaysAdmin, isNorthstarAdmin, isWhitelisted, isLoading, fetchUser, refetchUser } = useUserStore();
  const supabase = createClient();

  // `supabase` is intentionally omitted: it's the module-level singleton from createClient(),
  // so its reference is stable. Including it (back when createClient() built a fresh client per
  // render) made this effect refire every render and, for anonymous visitors whose `user` never
  // latches, spun an infinite fetchUser→setState→render loop that leaked Supabase clients.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!user && !isLoading) {
      fetchUser(supabase);
    }
  }, [user, isLoading, fetchUser]);

  return { user, isNowadaysAdmin, isNorthstarAdmin, isWhitelisted, isLoading, refetchUser };
};
